import React, { useEffect } from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";

import TestsRequests from "services/tests";

import ParticipantsTableHeading from "./ParticipantsTableHeading";
import ParticipantsTableItem from "./ParticipantsTableItems";

const ParticipantsTable = ({ searchMode, searchInput }) => {
    const dispatch = useDispatch();
    const { participants, participantsCurrentPage, participantsTotalPage } = useSelector(
      ({ tests }) => tests
    );
  
    useEffect(() => {
      if (searchMode) {
        dispatch(TestsRequests.getParticipants(1, searchInput));
      } else {
        dispatch(TestsRequests.getParticipants(1));
      }
    }, [searchInput, searchMode]);
  
    const handleChangePagination = (_, value) => {
      if (searchMode) {
        dispatch(TestsRequests.getParticipants(value, searchInput));
      } else {
        dispatch(TestsRequests.getParticipants(value));
      }
    };
  
    return (
      <div className="Cmt-table-responsive">
        {participants &&
          (participants.length === 0 ? (
            <Box
              display={"flex"}
              justifyContent={"center"}
              paddingTop={"30px"}
              paddingBottom={"20px"}
            >
              <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
            </Box>
          ) : (
            <Table>
              <TableHead>
                <ParticipantsTableHeading />
              </TableHead>
              <TableBody>
                {participants.map((item) => (
                  <ParticipantsTableItem
                    data={item}
                    key={item._id}
                  />
                ))}
              </TableBody>
            </Table>
          ))}
        {participants.length !== 0 ? (
          <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
            <Pagination
              count={participantsTotalPage}
              color="primary"
              page={participantsCurrentPage}
              onChange={handleChangePagination}
            />
          </Box>
        ) : null}
      </div>
    );
  };
  
  export default ParticipantsTable;